/**
 * 公司发展历程 / 时光墙数据源
 * ------------------------------------------------------------------
 * 【如何新增一条动态】
 * 1. 在下方 companyEvents 数组末尾追加一个对象即可，页面会自动：
 *    · 按 year 分组生成年份区块（新增年份无需改页面代码）
 *    · 顶部统计（事件总数 / 跨越年份 / 里程碑数）自动重算
 * 2. 字段说明：
 *    year      Number  年份，如 2026
 *    month     Number  月份 1-12，如 3（页面自动补零显示 03）
 *    title     String  事件标题（必须真实，勿臆造）
 *    category  String  分类 key，取值见 CATEGORIES（不在此表内会自动回落为"其他"）
 *    milestone Boolean 是否为里程碑事件（节点加大 + 光晕 + 卡片主色竖线 + 追加「里程碑」标记），建议每 3-5 年 1-2 条
 * 3. 数组顺序任意：页面统一按 year 降序 + month 降序渲染（最新在最前，2026-09-11 改）。
 *    新增一条只要写对 year/month，就会自动落进对应年份组、组内按月份倒序。
 * ------------------------------------------------------------------
 */

/** 分类字典（label 用于展示；颜色统一走品牌色，分类仅以中性 chip 呈现，不参与配色竞争） */
export const CATEGORIES = {
  milestone: { label: "里程碑" },
  honor: { label: "资质荣誉" },
  capital: { label: "资本金融" },
  partner: { label: "合作生态" },
  research: { label: "产学研" },
};

/** 公司发展历程事件列表（2014 - 至今）
 *  注：保留全部历史事件；以下 7 条在保留各自【原分类】的基础上，额外标记为里程碑
 *  （milestone: true），页面会同时展示原分类 chip 与「里程碑」标记，而不是用里程碑覆盖原分类：
 *    正式成立 / 芯联投资 / 高企+双软认证 / 海南高企政府补贴 / 海南省创新型中小企业 /
 *    国家级科技型中小企业 / 海南省高新技术种子企业。
 */
export const companyEvents = [
  {
    year: 2014,
    month: 9,
    title: "海南华德科技有限公司正式成立",
    category: "milestone",
    milestone: true,
  },
  {
    year: 2020,
    month: 8,
    title: "对外投资“芯联(海南)医疗科技有限公司”",
    category: "partner",
    milestone: true,
  },
  {
    year: 2020,
    month: 12,
    title: "荣获国家高新技术企业认证，荣获海南省双软企业认证",
    category: "honor",
    milestone: true,
  },
  {
    year: 2021,
    month: 3,
    title: "与重庆信科设计有限公司签订医疗行业信息化战略合作协议",
    category: "partner",
    milestone: false,
  },
  {
    year: 2021,
    month: 6,
    title: "成为日向科技(深圳)有限公司智慧病房、智慧门诊产品海南总代理",
    category: "partner",
    milestone: false,
  },
  {
    year: 2021,
    month: 7,
    title: "获得海南省首笔“知识产权质押融资贷款”授信",
    category: "capital",
    milestone: false,
  },
  {
    year: 2021,
    month: 9,
    title: "获得海南高新技术企业政府补贴奖励",
    category: "capital",
    milestone: true,
  },
  {
    year: 2022,
    month: 9,
    title: "获得海南省科技信贷风险补偿资金授信",
    category: "capital",
    milestone: false,
  },
  {
    year: 2022,
    month: 12,
    title: "再次荣获海南省软件企业认证",
    category: "honor",
    milestone: false,
  },
  {
    year: 2023,
    month: 4,
    title: "荣获海南省创新型中小企业称号",
    category: "honor",
    milestone: true,
  },
  {
    year: 2023,
    month: 6,
    title: "与琼台师范学院共建实践教学基地",
    category: "research",
    milestone: false,
  },
  {
    year: 2023,
    month: 8,
    title: "荣获国家级科技型中小企业称号",
    category: "honor",
    milestone: true,
  },
  {
    year: 2023,
    month: 8,
    title: "荣获海口市龙华区就业见习基地称号",
    category: "honor",
    milestone: false,
  },
  {
    year: 2023,
    month: 9,
    title: "与海南省人民医院成功联合申报海南省科技创新项目",
    category: "research",
    milestone: false,
  },
  {
    year: 2023,
    month: 11,
    title: "再次通过国家高新技术企业评审",
    category: "honor",
    milestone: false,
  },
  {
    year: 2023,
    month: 12,
    title: "荣获海南省高新技术企业种子企业称号",
    category: "honor",
    milestone: true,
  },
  {
    year: 2024,
    month: 1,
    title: "荣获2023年海南省优秀数字化转型服务商称号",
    category: "honor",
    milestone: false,
  },
  {
    year: 2024,
    month: 1,
    title: "大数据产业联盟单位",
    category: "honor",
    milestone: false,
  },
  {
    year: 2025,
    month: 3,
    title: "荣获海南省科技型中小企业称号",
    category: "honor",
    milestone: false,
  },
  {
    year: 2025,
    month: 11,
    title: "第八届智慧医疗创新大赛海南决赛暨海南省第二届数字健康创新大赛一等奖",
    category: "honor",
    milestone: false,
  },
  {
    year: 2025,
    month: 11,
    title: "第八届智慧医疗创新大赛海南决赛暨海南省第二届数字健康创新大赛最佳原创奖",
    category: "honor",
    milestone: false,
  },
  {
    year: 2025,
    month: 11,
    title: "第三届数字健康大会暨三医联运发展论坛论文征集比赛三等奖",
    category: "honor",
    milestone: false,
  },
  {
    year: 2026,
    month: 1,
    title: "2025年海南省优秀大数据应用案例",
    category: "honor",
    milestone: false,
  },
  {
    year: 2026,
    month: 4,
    title: "荣获海南省创新型中小企业称号",
    category: "honor",
    milestone: false,
  },
  {
    year: 2026,
    month: 6,
    title: "第八届智慧医疗创新大赛全国总决赛应用创新赛道优秀奖",
    category: "honor",
    milestone: false,
  },
  {
    year: 2026,
    month: 8,
    title: "荣获国家级科技型中小企业称号",
    category: "honor",
    milestone: false,
  },
  {
    year: 2026,
    month: 9,
    title: "2026年“数据要素X”大赛海南分赛医疗健康赛道一等奖",
    category: "honor",
    milestone: false,
  },
];

/**
 * 按年份分组（正序：早 → 晚）
 * 新增数据无需改动此函数，年份区块会自动生成。
 */
export function groupByYear(list) {
  const map = {};
  list.forEach((item) => {
    if (!map[item.year]) map[item.year] = [];
    map[item.year].push(item);
  });
  return Object.keys(map)
    .map(Number)
    .sort((a, b) => a - b)
    .map((year) => ({ year, items: map[year] }));
}

export default companyEvents;



// WEBPACK FOOTER //
// ./src/assets/data/companyEvents.js